// extracted by mini-css-extract-plugin
export default {"root":"CompanyUsersView_root__qhp-p","list":"CompanyUsersView_list__L5e-z"};